//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RadioSwitch from "@/components/RadioSwitch.vue";
import CAvatar from "@/components/CAvatar.vue";
import { PRODUCTID, getUserInfo } from "@/utils/auth";
import OrderService from "@/api/orderService";
import WxService from "@/api/wxService";
import WxJsSdk from "@/utils/wxJsSdk";
import SysUtils from "@/utils/sysUtils";

export default {
  data() {
    return {
      disabled: false, // 是否禁用提交操作
      showExchange: false, // 是否可以兑换
      selectAddress: "",
      account: 0, // 选择的数量
      switchs: ["在线支付", "运费到付"],
      payment: 0, // 支付方式
      exchangeNum: 0,
      extractIncrement: 30, // 数字步进器每一步增减多少
      extractMaxQuantity: 840, // 最大限制数量
      delivermoney: 0, // 实际支付快递费
      freight: 0, // 本应支付运费，只在会员生日优惠时显示
      showBirthday: false, // 是否显示生日优惠
      lastQuantity: 0, // 剩余抢提数量
    };
  },
  computed: {
    userInfo: function () {
      return getUserInfo();
    },
    stock: function () {
      return this.$route.query.stock;
    },
    product: function () {
      let product = this.$route.query.product;
      if (product) {
        return JSON.parse(product);
      } else {
        return "";
      }
    },
    loveIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/love.png");
      } else {
        return require("../../assets/theme_black/love.png");
      }
    },
    minusIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/minus2.png");
      } else {
        return require("../../assets/theme_black/minus.png");
      }
    },
    plusIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/plus2.png");
      } else {
        return require("../../assets/theme_black/plus.png");
      }
    },
    pickupIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/pickup.png");
      } else {
        return require("../../assets/theme_black/pickup.png");
      }
    },
    remindIcon: function () {
      if (this.$root.themeType == "yellow") {
        return require("../../assets/theme_yellow/remind.png");
      } else {
        return require("../../assets/theme_black/remind.png");
      }
    },
    isTime: function () {
      let now = new Date().getTime();
      let endTime = new Date("2020/11/21 00:00:00").getTime();
      if (now <= endTime) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    if (SysUtils.isWeiXin()) {
      let url = window.location.href.split("#")[0];
      // 获取微信config配置，配置支付和分享环境配置
      WxService.getConfig(encodeURIComponent(url))
        .then((res) => {
          if (res) {
            this.$wechat.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.appId, // 必填，公众号的唯一标识
              timestamp: res.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.nonceStr, // 必填，生成签名的随机串
              signature: res.signature, // 必填，签名
              jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
            });
          }
        })
        .catch((err) => {
          this.$vux.toast.text(err.msg);
        });
    }

    if (this.product) {
      this.extractIncrement = Number(this.product.extractIncrement);
      this.extractMaxQuantity = Number(this.product.extractMaxQuantity);
      // 控制哪些产品详情显示兑换说明
      if (
        this.product.key == "8153978189986300" ||
        this.product.key == "8156213789948654" ||
        this.product.key == "8158735277245403" ||
        this.product.key == "8160223245934659" ||
        this.product.key == "8160367516337895" ||
        this.product.key == "1383959923502743554" ||
        this.product.key == "1383959923502743555" ||
        this.product.key == "8156213789948655"||
        this.product.key == "8153724996370403"||
        this.product.key == "8156213789948656"||
        this.product.key == "1647779951578025985"
      ) {
        this.showExchange = true;
        if (this.account > 0) {
          this.handleCalc(this.account);
        }
      } else {
        this.showExchange = false;
      }

      // 当商品是小蓝时，查询剩余抢提数量
      if(this.product.key == "1383959923502743554"){
        this.getLastCount(this.product.key);
      }
    }

    let selectAddress = sessionStorage.getItem("TEMP_SELECT_ADDRESS");
    if (selectAddress) {
      selectAddress = JSON.parse(selectAddress);
      this.selectAddress = selectAddress;
    }

    // 判断是否是用户生日
    try {
      let isBirthday = this.userInfo.birthdayFlag; // 当天是否是该用户的生日 1是0否
      if (isBirthday == 1) {
        this.showBirthday = true;
      } else {
        this.showBirthday = false;
      }
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    /**
     * 当当前产品是小蓝是，查询当前剩余可抢提数量
     */
    getLastCount(key){
      OrderService.getLastCount(key).then(res => {
        let data = res.data;
        this.lastQuantity = data.quantity; // 剩余可抢提数量
        this.extractMaxQuantity = data.quantity; // 用户最大可提货数量为剩余可抢提数量
      })
    },
    /**
     * 进入地址列表选择地址
     */
    toSelectAddress() {
      this.$router.push({
        path: "/addressList",
        query: {
          scene: "select",
        },
      });
    },
    /**
     * 计算当前运费
     */
    computerFreight() {
      if (this.selectAddress.id && this.product.key) {
        if (this.account <= 0 || this.account == "") {
          this.$vux.toast.text("请选择数量");
          this.delivermoney = 0;
        } else {
          OrderService.getFreight(this.account, this.selectAddress.id, this.product.key)
            .then((res) => {
              // 如果当前是在线支付
              if (this.payment == 0) {
                this.delivermoney = res.data.paymentAmount; // 实际支付运费
                this.freight = res.data.freight; // 计算所得本应支付运费
              }
            })
            .catch((err) => {
              this.$vux.toast.text(err.msg);
            });
        }
      }
    },
    /**
     * 商品兑换比例计算
     */
    handleCalc(newNum, oldNum) {
      if (newNum == "") newNum = 0;
      // 如果当前中选的是面膜或者裸藻，根据相应的比例计算可兑换的双蛋白数量
      let exchangeNum = 0;
      // if (this.product.key == "8153978189986300") {
      //   // exchangeNum = newNum * 0.375;
      //   exchangeNum = newNum * 0.1875;
      // } else if (this.product.key == "8156213789948654") {
      //   exchangeNum = newNum * 0.9;
      // } else if (this.product.key == "8158735277245403") {
      //   exchangeNum = parseInt(newNum * 1.1667);
      // }
      const postData = {
        sourceProductId: this.product.key,
        sourceProductQuantity: newNum,
        targetProductId: PRODUCTID,
      };
      OrderService.calcExchange(postData)
        .then((res) => {
          exchangeNum = res.data.targetProductQuantity;

          // 如果兑换需求量大于当前用户的库存量，提示用户补货
          if (exchangeNum > this.stock) {
            var self = this;
            setTimeout(function () {
              self.account = oldNum ? oldNum : 0;
            }, 500);
            this.$vux.alert.show({
              title: "温馨提示",
              content: "亲爱哒，您当前的双蛋白库存不足，请及时补货哦~",
            });
          } else {
            this.exchangeNum = exchangeNum;
          }
        })
        .catch((err) => {
          this.$vux.toast.text(err.msg);
        });
    },
    /**
     * 点击提交操作，执行创建提货订单操作
     */
    handleSubmit() {
      const self = this;
      if (!this.selectAddress) {
        this.$vux.toast.text("请选择地址");
      } else if (this.account <= 0) {
        this.$vux.toast.text("请选择数量");
      } else {
        let productList = [
          {
            productId: PRODUCTID,
            num: this.account,
            productSpecId: this.product.key,
          },
        ];
        if (!this.disabled) {
          this.disabled = true;
          const postData = {
            productId: PRODUCTID,
            productList: productList,
            freightType: this.payment,
            addrId: this.selectAddress.id,
          };
          OrderService.extract(postData)
            .then((res) => {
              // 如果当前选择在线支付，并且支付状态为0时（0表示未支付，1表示已支付），调用微信支付
              // 当用户生日时，支付状态为1，因为免运费，所以不需要调用微信支付操作
              if (this.payment == 0 && res.data.payStatus == "0") {
                return OrderService.extractWxPay(res.data.id);
              } else {
                sessionStorage.removeItem("TEMP_SELECT_ADDRESS");
                setTimeout(() => {
                  this.$vux.toast.text("操作成功");
                }, 100);
                this.$router.go(-1);
                return;
              }
            })
            .then((res) => {
              this.disabled = false;
              const wxPayData = {
                nonceStr: res.data.nonceStr,
                package: res.data.package,
                paySign: res.data.paySign,
                signType: res.data.signType,
                timestamp: res.data.timeStamp,
              };
              WxJsSdk.chooseWXPay(wxPayData)
                .then((result) => {
                  // 如果当前取消了支付
                  if (result.errMsg == "chooseWXPay:cancel") {
                    // res.payFlowId
                    this.$vux.confirm.show({
                      // 组件除show外的属性
                      title: "提示",
                      content:
                        "扣减库存成功 <svg class='icon' aria-hidden='true'><use xlink:href='#iconsuccess-green' /></svg><br />提货订单生成成功 <svg class='icon' aria-hidden='true'><use xlink:href='#iconsuccess-green' /></svg><br />运费支付失败 <svg class='icon' aria-hidden='true'><use xlink:href='#icondeleteimg' /></svg>",
                      confirmText: "去支付运费",
                      cancelText: "继续提货",
                      onCancel() {},
                      onConfirm() {
                        // 跳转到提货记录页
                        self.$router.push({
                          path: "/deliveryList",
                        });
                      },
                    });
                  } else {
                    sessionStorage.removeItem("TEMP_SELECT_ADDRESS");
                    this.$vux.toast.text("操作成功");
                    this.$router.go(-1);
                  }
                })
                .catch((err) => {
                  console.log("支付失败:-------------");
                  console.log(err);
                });
            })
            .catch((err) => {
              this.disabled = false;
              this.$vux.toast.text(err.msg);
            });
        }
      }
    },
    clickMinus() {
      this.account -= this.extractIncrement;
      if (this.account <= 0) {
        this.account = 0;
      }
    },
    clickPlus() {
      this.account += this.extractIncrement;
      if (this.account >= this.extractMaxQuantity) {
        this.account = this.extractMaxQuantity;
      }
      if(this.extractMaxQuantity <=0){
        this.$vux.toast.text("可提货数量不足");
      }
    },
    handleBlur() {
      if (this.account <= 0) {
        this.account = 0;
      } else if (this.account >= this.extractMaxQuantity) {
        this.account = this.extractMaxQuantity;
      }
    },
    clickBack() {
      this.$router.go(-1);
    },
  },
  filters: {
    filtValueName: function (e) {
      if (e == "裸藻圆苞车前子壳固体饮料") {
        return "裸藻";
      }else if (e == "绿孔雀限量版椰子味裸藻圆苞车前子固体饮料") {
        return "椰子味裸藻";
      }else if (e == "家庭装-胶原蛋白弹性蛋白固体饮料") {
        return "家庭装";
      } else if (e == "益生菌 · 即食型乳酸菌") {
        return "益生菌";
      } else if (e == "限量版小蓝透明质酸钠胶原蛋白弹性蛋白固体饮料") {
        return "小蓝";
      } else if (e == "胶原蛋白弹性蛋白玻尿酸红石榴味固体饮料") {
        return "红石榴";
      } else if (e == "荔枝玫瑰味胶原蛋白弹性蛋白固体饮料") {
        return "荔枝玫瑰味胶原蛋白弹性蛋白固体饮料";
      } else {
        return e;
      }
    },
  },
  watch: {
    account: function (newNum, oldNum) {
      this.computerFreight();
      this.handleCalc(newNum, oldNum);
    },
    payment: function (e) {
      if (e == 0) {
        this.computerFreight();
      } else {
        this.delivermoney = 0;
      }
    },
  },
  components: {
    RadioSwitch,
    CAvatar,
  },
};



// WEBPACK FOOTER //
// ./src/views/inventory/delivery.vue